const CONFIG = {
  USER_COUNT: 1,
  PAYMENT: 0,
  START_HOURS: 9
}

export default CONFIG;
